import { withInstall } from '@ll-plus/utils'

import Modal from './src/modal.vue'

export const LlModal = withInstall(Modal)
export default LlModal
export * from './src/modal'

declare module 'vue' {
  export interface GlobalComponents {
    LlModal: typeof Modal
  }
}
